import { StockIsFavorite } from '../StockIsFavorite/StockIsFavorite.component';
import { LinkProps } from 'next/link';
import { ProductCategoryCode, ProductType, UserProductType } from 'pleinchamp-api-client';
import React, { FC } from 'react';
import { BasicLink } from '@components/buttons/BasicLink/BasicLink.component';
import { PrimaryButton } from '@components/buttons/FlatButton/FlatButton.component';
import { Text } from '@components/Text/Text.component';
import { CircleChevronDownIcon } from '@icons/CircleChevronDown.icon';
import { PlcAccordion } from '@layout/components/PlcAccordion/PlcAccordion.component';
import { ElementComponents } from '@stocks/business/StocksTable.utils';
import { buildContent } from '@stocks/components/StockDetails/StockDetails.component';
import { PlcColor } from '@styles/colors';
import styles from './StocksHomeAccordionBody.module.scss';

export const StockHomeAccordionRow: FC<{
  firstElement: ElementComponents;
  linkProps: LinkProps;
  productType: ProductType;
}> = ({ firstElement, linkProps, productType }) => {
  const { id } = productType;
  const titleComponent = (
    <div className={styles['stocks-accordion-title']}>
      <StockIsFavorite productType={productType} />
      <Text flavour="midnight-green" tag="h3" variant="h6">
        {firstElement.raw}
      </Text>
    </div>
  );

  const body = (
    <div className={styles['stocks-accordion-body']}>
      {buildContent(
        productType as UserProductType,
        'full',
        productType.productCategoryCode === ProductCategoryCode.CommoditiesFutures,
        false
      )}
      <BasicLink className={styles['stocks-accordion-button']} {...linkProps}>
        <PrimaryButton isLightGreen isSmall textProps={{ i18nKey: 'stocks.home.button.favorites.details' }} />
      </BasicLink>
    </div>
  );

  const chevronIcon = (
    <CircleChevronDownIcon
      className={styles.span}
      fill={PlcColor.GREY}
      fillColor={PlcColor.GREEN}
      height={20}
      width={20}
    />
  );

  return (
    <PlcAccordion
      key={id}
      className={styles['stocks-plc-accordion']}
      expandIcon={chevronIcon}
      titleComponent={titleComponent}
    >
      {body}
    </PlcAccordion>
  );
};
